export default "__VITE_ASSET__CO9Q6$E$__"